'use strict';

Fotobook.holidays = {
    getDate(date) {
        if (!(date instanceof Date)) {
            date = new Date(date);
        }
        return this.user.getDate(date) || this.common.getDate(date);
    },

    findCellsInProject(date, repeat) {
        let attributeSelector;
        if (repeat) {
            attributeSelector = `[data-date$="${date.substring(5)}"]`;
        } else {
            attributeSelector = `[data-date="${date}"]`;
        }
        return $(`.day-inside-month${attributeSelector}`);
    },
};
